import GenericPage from '../page-generic';
import image from '../../assets/BiError.svg';

export default function CashBoxAlarmPage() {
	return (
		<GenericPage
			title={'CASH BOX REMOVED INCORRECTLY!'}
			message={'Please reinsert the cash box to continue operation.'}
			imageSrc={image}
			imageAlt={'Error'}
		/>
	);
}
